import { dispatchEvent } from 'redux-ruleset'

export const chipClick = (label: string) =>
  dispatchEvent({
    type: 'listingCategoryTree/chipClick' as const,
    payload: {
      label
    }
  })

export const tagCategoryClick = (dyPathId: string) =>
  dispatchEvent({
    type: 'listingCategoryTree/tagCategoryClick' as const,
    payload: {
      dyPathId
    }
  })

export const sideNavigationClick = (label: string) =>
  dispatchEvent({
    type: 'listingCategoryTree/SIDE_NAVIGATION_CLICK' as const,
    payload: {
      label
    }
  })

declare global {
  interface RulesetDispatchEvents {
    'molecules/ListingCategoryTree':
      | ReturnType<typeof chipClick>
      | ReturnType<typeof tagCategoryClick>
      | ReturnType<typeof sideNavigationClick>
  }
}
